import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import baseReduce from '../features/base/baseSlice'
import componentReducer from '../features/components/componentSlice'
import dataReducer from '../features/data/dataSlice'
import fieldsReducer from '../features/fields/fieldsSlice'
import pageReducer, { setHasChanges } from '../features/pages/pageSlice'
import toolReducer from '../features/tools/toolSlice'

export const unsavedChangesMiddleware = (storeAPI) => (next) => (action) => {
  const result = next(action)

  // List of action prefixes that should trigger an unsaved change warning
  const trackableSlices = ['components/', 'data/']

  // Specific actions to ignore even if they match the prefixes above
  const ignoredActions = ['components/load', 'components/setSelected', 'data/loadTemplates']

  const isTrackable = trackableSlices.some((slice) => action.type.startsWith(slice))
  const isIgnored = ignoredActions.some((ignored) => action.type.startsWith(ignored))

  if (isTrackable && !isIgnored) {
    storeAPI.dispatch(setHasChanges(true))
  }

  return result
}

const reducers = combineReducers({
  components: componentReducer,
  pages: pageReducer,
  tools: toolReducer,
  data: dataReducer,
  fields: fieldsReducer,
  base: baseReduce,
})

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(unsavedChangesMiddleware),
})

export default store
